@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <span class="busyLabel">Please Wait...</span>
    </div>
  </div>
}
@if (errorMessage()) {
  <div class="errorMessage">
    <pre>{{ errorMessage() }}</pre>
  </div>
}
<div class="toolbar">
  <span>
    <button matButton="text" (click)="backToEntity()" [disabled]="isBusy()">
      <span>
        <mat-icon>keyboard_arrow_left</mat-icon>
        <span>Back</span>
      </span>
    </button>
  </span>
  <span class="spacer"></span>
  @if (documents()) {
    <span>
      @if (selectedTab() === 0) {
        <button matButton="text" (click)="showGenerateDialog()" [disabled]="isBusy()">
          <span>
            <mat-icon>add</mat-icon>
            <span>Create</span>
          </span>
        </button>
      }
      <button matButton="text" (click)="showUploadDialog()" [disabled]="isBusy()">
        <span>
          <mat-icon>file_upload</mat-icon>
          <span>Upload</span>
        </span>
      </button>
    </span>
  }
</div>
<mat-tab-group [(selectedIndex)]="selectedTab" (selectedTabChange)="loadSelectedTab()" [mat-stretch-tabs]="false">
  <mat-tab label="All Documents">
    @if (documents()) {
      <div>
        <div class="customScenariosSection">
          <table class="reportTable scenarioTable">
            <thead>
              <tr>
                <td class="tableCell headerCell centeredCell">Document Name</td>
                <td class="tableCell headerCell centeredCell">Type</td>
                <td class="tableCell headerCell centeredCell">Loaded By</td>
                <td class="tableCell headerCell centeredCell">Date Loaded</td>
                <td class="tableCell headerCell centeredCell">Entity ID</td>
                <td class="tableCell headerCell centeredCell">Source</td>
              </tr>
            </thead>
            @if (documents().length > 0) {
              @for (document of documents(); track document) {
                <tr>
                  <td (click)="download(document)"
                    class="tableCell downloadDocumentCell">{{ document.documentName }}
                  </td>
                  <td class="tableCell">{{ document.documentType }}</td>
                  <td class="tableCell">{{ document.userName }}</td>
                  <td class="tableCell">{{ document.lastUpdate | date: 'MM/dd/yyyy h:mm:ss a':'UTC' }}</td>
                  <td class="tableCell">{{ document.entityKey.entityId }}</td>
                  <td class="tableCell">{{ document.uploadSource }}</td>
                </tr>
              }
            }
            @if (documents().length === 0) {
              <tr>
                <td class="tableCell centeredCell" colspan="6">No documents found</td>
              </tr>
            }
          </table>
        </div>
      </div>
    }
  </mat-tab>
  <mat-tab label="Recent Documents">
    @if (recentDocuments()) {
      <div>
        <div class="customScenariosSection">
          <table class="reportTable scenarioTable">
            <thead>
              <tr>
                <td class="tableCell headerCell centeredCell">Document Name</td>
                <td class="tableCell headerCell centeredCell">Type</td>
                <td class="tableCell headerCell centeredCell">Loaded By</td>
                <td class="tableCell headerCell centeredCell">Date Loaded</td>
                <td class="tableCell headerCell centeredCell">Entity ID</td>
                <td class="tableCell headerCell centeredCell">Source</td>
              </tr>
            </thead>
            @if (recentDocuments().length > 0) {
              @for (document of recentDocuments(); track document) {
                <tr>
                  <td (click)="download(document)"
                    class="tableCell downloadDocumentCell">{{ document.documentName }}
                  </td>
                  <td class="tableCell">{{ document.documentType }}</td>
                  <td class="tableCell">{{ document.userName }}</td>
                  <td class="tableCell">{{ document.lastUpdate | date: 'MM/dd/yyyy h:mm:ss a':'UTC' }}</td>
                  <td class="tableCell">{{ document.entityKey.entityId }}</td>
                  <td class="tableCell">{{ document.uploadSource }}</td>
                </tr>
              }
            }
            @if (documents().length === 0) {
              <tr>
                <td class="tableCell centeredCell" colspan="6">No documents found</td>
              </tr>
            }
          </table>
        </div>
      </div>
    }
  </mat-tab>
  @if (!isSchedule()) {
    <mat-tab label="Credit Documents">
      <div class="customScenariosSection">
        <table class="reportTable scenarioTable">
          <thead>
            <tr>
              <td class="tableCell headerCell centeredCell">Document Name</td>
              <td class="tableCell headerCell centeredCell">Type</td>
              <td class="tableCell headerCell centeredCell">Loaded By</td>
              <td class="tableCell headerCell centeredCell">Date Loaded</td>
              <td class="tableCell headerCell centeredCell">Entity ID</td>
              <td class="tableCell headerCell centeredCell">Source</td>
              <td class="tableCell headerCell centeredCell">Status</td>
              @if (showApprovalButtons()) {
                <td class="tableCell headerCell centeredCell buttonCell"></td>
                <td class="tableCell headerCell centeredCell buttonCell"></td>
              }
            </tr>
          </thead>
          @if (creditDocuments() && creditDocuments().length > 0) {
            @for (document of creditDocuments(); track document) {
              <tr>
                <td (click)="download(document)"
                  class="tableCell downloadDocumentCell">{{ document.documentName }}
                </td>
                <td class="tableCell">{{ document.documentType }}</td>
                <td class="tableCell">{{ document.userName }}</td>
                <td class="tableCell">{{ document.lastUpdate | date: 'MM/dd/yyyy h:mm:ss a':'UTC' }}</td>
                <td class="tableCell">{{ document.entityKey.entityId }}</td>
                <td class="tableCell">{{ document.uploadSource }}</td>
                <td class="tableCell">{{ document.status }}</td>
                @if (showDocumentApprovalButtons(document)) {
                  <td
                    class="tableCell buttonCell">
                    <button matButton="text" class="approveButton" (click)="approveCreditDocument(document)">
                      <span>
                        <mat-icon class="size-16">done</mat-icon>
                        <span class="buttonLabel">Approve</span>
                      </span>
                    </button>
                  </td>
                  <td
                    class="tableCell buttonCell">
                    <button matButton="text" class="denyButton" (click)="denyCreditDocument(document)">
                      <span>
                        <mat-icon class="size-16">clear</mat-icon>
                        <span class="buttonLabel">Deny</span>
                      </span>
                    </button>
                  </td>
                }
              </tr>
            }
          }
          @if (!creditDocuments() || creditDocuments().length === 0) {
            <tr>
              @if (isInCreditGroup()) {
                <td class="tableCell centeredCell" colspan="9">No credit documents
                  found
                </td>
              }
              @if (!isInCreditGroup()) {
                <td class="tableCell centeredCell" colspan="7">No credit documents
                  found
                </td>
              }
            </tr>
          }
        </table>
      </div>
    </mat-tab>
  }
</mat-tab-group>
